<template>
  <div>
    <Dialog v-model:visible="display">
      <template #header>
        <h3>Warning</h3>
      </template>
      Add Demo
    </Dialog>
    <Dialog
      v-model:visible="display1"
      @hide="closeModal"
      :modal="true"
      :responsive="true"
      :style="{ width: '20vw' }"
    >
      <template #header>
        <h4>Visit Reason Name is require</h4>
      </template>
      <template #footer>
        <Button
          label="No"
          icon="pi pi-times"
          @click="closeBasic"
          class="p-button-text"
        />
        <Button label="Yes" icon="pi pi-check" @click="closeBasic" autofocus />
      </template>
    </Dialog>
    <Dialog
      v-model:visible="display3"
      @hide="closeModal"
      :modal="true"
      :responsive="true"
      :style="{ width: '20vw' }"
    >
      <template #header>
        <h4>Are you sure?</h4>
      </template>
      <template #footer>
        <Button
          label="No"
          icon="pi pi-times"
          @click="closeBasic1()"
          class="p-button-text"
        />
        <Button
          label="Yes"
          icon="pi pi-check"
          @click="deleteVisitTypeClick_1()"
          autofocus
        />
      </template>
    </Dialog>
    <Dialog
      v-model:visible="display4"
      @hide="closeModal"
      :modal="true"
      :responsive="true"
      :style="{ width: '20vw' }"
    >
      <template #header>
        <h4>Are you sure?</h4>
      </template>
      <template #footer>
        <Button
          label="No"
          icon="pi pi-times"
          @click="closeBasic11()"
          class="p-button-text"
        />
        <Button
          label="Yes"
          icon="pi pi-check"
          @click="deleteVisitTypeClick_2()"
          autofocus
        />
      </template>
    </Dialog>
    <Dialog
      v-model:visible="display5"
      @hide="closeModal"
      :modal="true"
      :responsive="true"
      :style="{ width: '20vw' }"
    >
      <template #header>
        <h4>Are you sure?</h4>
      </template>
      <template #footer>
        <Button
          label="No"
          icon="pi pi-times"
          @click="closeBasicActive()"
          class="p-button-text"
        />
        <Button
          label="Yes"
          icon="pi pi-check"
          @click="ActiveReason()"
          autofocus
        />
      </template>
    </Dialog>
    <Dialog v-model:visible="display2">
      <template #header>
        <h3>Required</h3>
      </template>
    </Dialog>
    <!-- <MMultiselect></MMultiselect> -->
    <!-- ============================================================== -->
    <!-- Page wrapper  -->
    <!-- ============================================================== -->
    <div class="page-wrapper">
      <!-- ============================================================== -->
      <!-- Container fluid  -->
      <!-- ============================================================== -->
      <div class="container-fluid">
        <!-- ============================================================== -->
        <!-- Bread crumb and right sidebar toggle -->
        <!-- ============================================================== -->
        <div class="row page-titles">
          <div class="col-md-5 align-self-center">
            <h4 class="text-themecolor">Visit Type</h4>
          </div>
          <div class="col-md-7 align-self-center text-right">
            <div class="d-flex justify-content-end align-items-center">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="dashboard">Home</a>
                </li>
                <li class="breadcrumb-item active">Visit Type</li>
              </ol>
            </div>
          </div>
        </div>

        <div class="row justify-content-end">
          <div class="col-sm-4">
            <div class="text-right">
              <button
                class="btn btn-success waves-effect mt-2 mb-2"
                type="button"
                data-toggle="modal"
                name="vType"
                @click="addNewStage"
                id="addNewStg_btn"
              >
                <i class="fas fa-plus fa-2x"></i>
              </button>
            </div>
          </div>
        </div>

        <div
          class="row justify-content-center"
          v-for="(vtl, ndx01) in visitTypeList.vtftl"
          :key="ndx01"
        >
          <div class="table-responsive step mb-5">
            <!--Stage-->
            <table class="table" style="margin-bottom: 0rem !important">
              <thead class="bg-info text-center text-white">
                <tr>
                  <th style="width: 24%" class="text-white boldsizeText">
                    {{ vtl.vt.name }}
                  </th>
                  <th class="boldText" style="width: 15%">Demo</th>
                  <th class="boldText" style="width: 15%">Questionnaire</th>
                  <th class="boldText" style="width: 15%">SMS</th>
                  <th class="boldText" style="width: 15%">Email</th>
                  <th class="boldText" style="width: 15%">
                    <a
                      class="btn-floating btn-sm btn-success"
                      type="button"
                      style="font-size: 1.5rem !important"
                      ><i
                        class="fas fa-arrow-up text-white"
                        @click="mainUpArrowClick(ndx01, vtl)"
                      ></i
                    ></a>
                    <span>&nbsp;&nbsp;</span>
                    <a
                      class="btn-floating btn-sm btn-success down"
                      type="button"
                      style="font-size: 1.5rem !important"
                      id="down"
                      ><i
                        class="fas fa-arrow-down text-white"
                        @click="mainDownArrowClick(ndx01, vtl)"
                      ></i
                    ></a>
                  </th>
                </tr>
              </thead>
              <tbody class="text-center">
                <tr class="bg-grey">
                  <td class="text-center trSpacing">
                    <div class="btn-group">
                      <button
                        type="button"
                        class="btn btn-success button-align-small"
                        data-toggle="modal"
                        data-target=""
                        :disabled="updButton == 0"
                        @click="editClick(vtl.vt.visitTypeId, ndx01)"
                      >
                        Edit
                      </button>
                      <button
                        type="button"
                        class="
                          btn btn-success
                          dropdown-toggle dropdown-toggle-split
                        "
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                        :disabled="delButton == 0"
                      >
                        <span class="sr-only">Toggle Dropdown</span>
                      </button>
                      <div class="dropdown-menu animated flipInY">
                        <a
                          class="dropdown-item"
                          @click="
                            deleteVisitTypeClick(vtl.vt.visitTypeId, ndx01)
                          "
                          id="vtArchiveV2"
                          >Archive</a
                        >
                      </div>
                    </div>
                  </td>
                  <th class="boldText">
                    <!-- <span class="bs-label label-success badgeBorder"
                      >Demo 01</span
                    > -->
                  </th>
                  <th class="boldText">
                    <!-- <span class="bs-label label-success badgeBorder"
                      >Questionnaire 01</span
                    > -->
                  </th>
                  <td class="trSpacing">
                    <!-- <span class="bs-label label-success badgeBorder"
                      >SMS 02</span
                    > -->
                  </td>
                  <td class="trSpacing">
                    <!-- <span class="bs-label label-success badgeBorder"
                      >Email 05</span
                    > -->
                  </td>
                  <td class="trSpacing">&nbsp;</td>
                </tr>
                <!-- eslint-disable -->
                <tr v-for="(vtdt, ndx02) in vtl.vtdt" :key="ndx02">
                  <!-- eslint-enable -->
                  <!-- usman1 -->
                  <td
                    v-if="vtdt.vtd.isDeleted == 0"
                    class="text-center boldsizeTextv2"
                  >
                    <span> {{ vtdt.vtd.reason }} </span>
                    <!-- <span v-else style="color:red;"> {{ vtdt.vtd.reason }} </span> -->
                  </td>
                  <th
                    v-if="vtdt.vtd.isDeleted == 0"
                    class="text-center trSpacing"
                  >
                    <div
                      v-for="(val, ndx03) in vtdt.selectedDemos"
                      :key="ndx03"
                      class="main-name-short"
                    >
                      <span class="bs-label label-success badgeBorder">
                        {{ val.questName }}
                      </span>
                      <!-- <span id="span11" v-else> {{ val.questName }} </span> -->
                      <p style="margin-top: 2ch"></p>
                    </div>
                  </th>
                  <th
                    v-if="vtdt.vtd.isDeleted == 0"
                    class="text-center trSpacing"
                  >
                    <div
                      v-for="(val1, ndx04) in vtdt.questList"
                      :key="ndx04"
                      class="main-name-short"
                    >
                      <span class="bs-label label-success badgeBorder">
                        {{ val1.questName }}
                      </span>
                      <!-- <span v-else id="span11"> {{ val1.questName }} </span> -->
                      <p style="margin-top: 2ch"></p>
                    </div>
                  </th>
                  <th
                    v-if="vtdt.vtd.isDeleted == 0"
                    class="text-center trSpacing"
                  >
                    <div
                      v-for="(vtdt1, ndx04) in vtdt.smsList"
                      :key="ndx04"
                      class="main-name-short"
                    >
                      <span class="bs-label label-success badgeBorder">
                        {{ vtdt1.name }}
                      </span>
                      <!-- <span v-else id="span11"> {{ vtdt1.name }} </span> -->
                      <p style="margin-top: 2ch"></p>
                      <!-- {{ showSms(vtdt) }} -->
                    </div>
                  </th>
                  <th
                    v-if="vtdt.vtd.isDeleted == 0"
                    class="text-center trSpacing"
                  >
                    <div
                      v-for="(vtdt1, ndx04) in vtdt.emailList"
                      :key="ndx04"
                      class="main-name-short"
                    >
                      <span class="bs-label label-success badgeBorder">
                        {{ vtdt1.name }}
                      </span>
                      <!-- <span v-else id="span11"> {{ vtdt1.name }} </span> -->
                      <p style="margin-top: 2ch"></p>
                    </div>
                  </th>
                  <td v-if="vtdt.vtd.isDeleted == 0">&nbsp;</td>
                </tr>
              </tbody>
            </table>
            <!--Stage-->
          </div>
        </div>
        <!-- ============================================================== -->
      </div>
      <!-- ============================================================== -->
      <!-- End Container fluid  -->
      <!-- ============================================================== -->
    </div>
    <!-- ============================================================== -->
    <!-- End Page wrapper  -->
    <!-- ============================================================== -->
    <!-- Stage Modal 112233-->
    <Dialog
      v-model:visible="displayThisComponent"
      :style="{ width: '70vw' }"
      @hide="closeModal"
      :modal="true"
      :responsive="true"
      :baseZIndex="1000"
    >
      <template #header>
        <h4 style="font-weight: bold">Update Visit Type and Reasons</h4>
        <button
          class="btn btn-outline-success waves-effect col-7 m-r-10"
          @click="updateVisitTypDetailReasonsClick()"
          id="UpdVst_btn"
        >
          Update Visit Type and Reasons
        </button>
        <button
          style="margin-left: 0"
          class="btn btn-success m-r-10"
          @click="addNewReason()"
          id="addNewRsn_btn1"
          type="button"
        >
          <i class="fa fa-plus"></i>
        </button>
      </template>
      <!-- <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button> -->

      <div class="modal-body mb-1 pt-2">
        <div class="vtabs customvtab">
          <ul class="nav nav-tabs tabs-vertical" role="tablist" id="step-tabs">
            <li class="nav-item fixed">
              <a
                @click="changeReasonActiveVal()"
                class="nav-link active"
                data-toggle="tab"
                href="#stage01"
                role="tab"
                id="AAA999"
                ><span class="boldText" id="FirstSelect">{{ showType }}</span>
              </a>
            </li>
            <!-- <li
              style="margin-left: 0px"
              class="nav-item step"
              v-for="(vtdt, ndx003) in singleVTL.vtdt"
              :key="ndx003"
            >
              <a
                @click="visitReasonClick(vtdt, ndx003, vtdt.vtd.visitDetailId)"
                class="nav-link"
                data-toggle="tab"
                role="tab"
                href="#step01"
              >
              <a class="nav-link active" data-toggle="tab" href="#stage01" role="tab" style="border: none;" id="AAA999">
                <div class="b" style="margin-left:0px; margin-top: 0px;">
                  <span class="boldText" id="FirstSelect">
                    {{ showType }}</span>
                </div>
              </a>
              </a>
            </li> -->
            <li
              style="margin-left: 0px"
              class="nav-item step"
              v-for="(vtdt, ndx003) in singleVTL.vtdt"
              :key="ndx003"
            >
              <a
                @click="GetVisitReason(vtdt, ndx003, vtdt.vtd.visitDetailId)"
                class="nav-link"
                :id="'navlink' + vtdt.vtd.visitDetailId"
                name="navlink-name"
                data-toggle="tab"
                role="tab"
                href="#step01"
              >
                <span class="hidden-xs-down">
                  <a @click="clickInnerUpButton(ndx003)">
                    <span class="btn-floating btn-sm btn-success up">
                      <i class="fas fa-arrow-up white-text"> </i>
                    </span>
                    &nbsp;
                  </a>
                  <a @click="clickInnerDownButton(ndx003)">
                    <span
                      style="margin-left: -10px"
                      class="btn-floating btn-sm btn-success down"
                      id="down"
                      ><i class="fas fa-arrow-down white-text"></i>
                    </span>
                  </a>
                  <span>
                    <div class="b">
                      <span v-if="vtdt.vtd.isDeleted == 0">
                        {{ vtdt.vtd.reason }}
                      </span>
                      <span v-else style="color: red">
                        {{ vtdt.vtd.reason }}
                      </span>
                    </div>
                  </span>

                  <!-- <span id="reasonHandle"> {{ vtdt.vtd.reason }} </span></span> -->
                </span>
              </a>
            </li>
          </ul>
          <!-- Tab panes -->
          <div class="tab-content">
            <div
              class="tab-pane active"
              id="stage01"
              role="tabpanel"
              style="width: 730px"
            >
              <div class="row" style="margin-left: 17px">
                <!-- <button
                  class="btn btn-outline-success waves-effect col-8 m-r-10"
                  @click="updateVisitTypeClick_1()"
                  id="UpdVtype_btn"
                >
                  Update Visit Type
                </button> -->
                <button
                  @click="ArchiveShow(dummyComm.extras, visitTypeIndex)"
                  class="btn btn-outline-danger waves-effect col-2"
                  id="vtArchiveV4"
                >
                  Archive
                </button>
              </div>

              <div class="modal-body">
                <h3 class="font-weight-bold h3Spacing">
                  Visit Type<span style="color: red"> *</span>
                </h3>
                <form class="floating-labels" onsubmit="return false;">
                  <div class="row">
                    <div class="col-lg-12">
                      <div class="form-group m-b-40 focused">
                        <input
                          style="width: 95%"
                          type="text"
                          class="form-control"
                          id=""
                          placeholder=""
                          maxlength="40"
                          v-model="vtlName"
                          @keydown.enter="updateVisitTypDetailReasonsClick()"
                        /><span class="bar"></span>
                        <!-- <label for="">{{ showType }}</label> -->
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            <div class="tab-pane" id="step01" role="tabpanel">
              <div class="row" style="margin-left: 0px">
                <div v-if="visitData.isDeleted == 0">
                  <button
                    style="width: 310px"
                    class="btn btn-outline-danger waves-effect col-4"
                    id="vtArchiveV3"
                    @click="ArchiveShow1(dummyComm.extras, visitDetailId)"
                  >
                    Archive
                  </button>
                </div>
                <div v-else>
                  <button
                    style="width: 310px"
                    @click="ActiveShow(dummyComm.extras, visitDetailId)"
                    class="btn btn-outline-success waves-effect col-4"
                    id="vtArchiveV3"
                  >
                    Active
                  </button>
                </div>
              </div>
              <div class="modal-body">
                <h3 class="font-weight-bold h3Spacing">
                  Visit Reason<span style="color: red"> *</span>
                </h3>
                <div class="row">
                  <div class="col-6">
                    <form class="floating-labels" onsubmit="return false;">
                      <div class="row">
                        <div class="col-lg-12">
                          <div class="form-group m-b-40" style="width: 360px">
                            <input
                              type="text"
                              class="form-control"
                              id=""
                              placeholder=""
                              maxlength="40"
                              v-model="reasonName"
                              @change="ReasonNameChange()"
                            /><span class="bar"></span>
                            <!-- <label for="">Visit Reason</label> -->
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                  <!-- 9999 -->
                  <div class="col-6 floating-labels">
                    <div
                      class="form-group m-b-40"
                      v-bind:class="[phys.length > 0 ? 'focused' : '']"
                      style="width: 360px"
                    >
                      <select
                        class="form-control p-0"
                        id=""
                        v-model="physicianId"
                        @change="physicianSelected($event)"
                      >
                        <option
                          v-for="ph in phys"
                          :key="ph.userId"
                          :value="ph.userId"
                        >
                          {{ ph.firstName }} {{ ph.lastName }}
                        </option>
                        <!-- <option>Physician 01</option>
                            <option>Physician 02</option>
                            <option>Physician 03</option> --></select
                      ><span class="bar"></span>
                      <label for="input6">Physicians</label>
                    </div>
                  </div>
                </div>

                <form onsubmit="return false;" class="floating-labels">
                  <!-- fifth row -->

                  <div class="row">
                    <div class="col">
                      <h3 class="font-weight-bold h3Spacing">
                        SMS
                        <span class="subText">
                          <a href="javascript:void(0)" class="mytooltip">
                            <i class="fas fa-exclamation-circle fa-sm"></i>
                            <span class="tooltip-content5">
                              <span class="tooltip-text3">
                                <span class="tooltip-inner2">
                                  <div class="timeline-panel">
                                    <div class="timeline-body">
                                      <p>
                                        Please be aware that the SMS will be
                                        sent after record has completed sign in
                                      </p>
                                    </div>
                                  </div>
                                </span>
                              </span>
                            </span>
                          </a>
                        </span>
                      </h3>

                      <MultiSelect
                        style="width: 378px"
                        v-model="smsSelected"
                        :options="smsList1"
                        optionLabel="smsName"
                        placeholder="Select Sms Templates"
                        display="chip"
                        @change="SmsDataChanged()"
                      />
                    </div>

                    <div class="col">
                      <h3 class="font-weight-bold h3Spacing">
                        Email
                        <span class="subText">
                          <a href="javascript:void(0)" class="mytooltip">
                            <i class="fas fa-exclamation-circle fa-sm"></i>
                            <span class="tooltip-content5">
                              <span class="tooltip-text3">
                                <span class="tooltip-inner2">
                                  <div class="timeline-panel">
                                    <div class="timeline-body">
                                      <p>
                                        Please be aware that the Email will be
                                        sent after record has completed sign in
                                      </p>
                                    </div>
                                  </div>
                                </span>
                              </span>
                            </span>
                          </a>
                        </span>
                      </h3>

                      <MultiSelect
                        style="width: 378px"
                        v-model="emailSelected"
                        :options="emailList1"
                        optionLabel="emailName"
                        placeholder="Select Email"
                        display="chip"
                        @change="EmailDataChanged()"
                      />
                    </div>
                  </div>
                  <!-- fifth row -->
                  <div class="row" style="margin-top:10px">
                    <div class="col">
                      <h3 class="font-weight-bold h3Spacing">
                        Tasks To-do
                        <span class="subText">
                          <a href="javascript:void(0)" class="mytooltip">
                            <i class="fas fa-exclamation-circle fa-sm"></i>
                            <span class="tooltip-content5">
                              <span class="tooltip-text3">
                                <span class="tooltip-inner2">
                                  <div class="timeline-panel">
                                    <div class="timeline-body">
                                      <p>
                                        Tasks that can be assigned
                                      </p>
                                    </div>
                                  </div>
                                </span>
                              </span>
                            </span>
                          </a>
                        </span>
                      </h3>

                      <MultiSelect
                        style="width: 378px"
                        v-model="taskSelected"
                        :options="taskOptions"
                        optionLabel="label"
                        placeholder="Select Task"
                        display="chip"
                        @change="EmailDataChanged()"
                      />
                    </div>
                  </div>
                </form>

                <!-- 0000 -->
                <!-- <div class="row"> -->

                <!-- **** Questionnaire table -->
                <div class="row" style="width: 100%; margin-left: 0px">
                  <div class="" id="" style="width: 800px">
                    <h3 class="font-weight-bold h3Spacing m-t-10">
                      <br />
                      Questionnaire
                    </h3>
                    <!-- <select
                          multiple="multiple"
                          id="questControl"
                          name="dummy009[]"
                        ></select> -->
                    <!-- this is List new section-->
                    <div id="" class="table-responsive">
                      <div
                        class="
                          dataTables_wrapper
                          container-fluid
                          dt-bootstrap4
                          no-footer
                        "
                      >
                        <div class="dataTables_length">
                          <span style="margin-right: 10px"
                            ><label for="">Show </label>
                          </span>
                          <select
                            v-model="pageSize"
                            class="form-control form-control-sm"
                            aria-label="Default select example"
                            @change="pageChange(1)"
                          >
                            <option selected>50</option>
                            <option value="100">100</option>
                            <option value="500">500</option>
                            <option value="1000">1000</option>
                            <option value="2000">2000</option>
                          </select>

                          <span style="margin-left: 10px">
                            <label for=""> Entries </label></span
                          >
                        </div>
                        <div class="dataTables_filter">
                          <span class="float-right">
                            <span style="margin-right: 10px"
                              ><label for="Search">Search:</label></span
                            >
                            <input
                              type="text"
                              v-on:keyup="SearchDataTable()"
                              v-model="filter"
                              autocomplete="off"
                              name=""
                              id="quests1"
                            />
                          </span>
                        </div>
                      </div>
                      <table
                        data-height="300"
                        class="
                          table
                          display
                          table-bordered table-striped
                          no-wrap
                          noSearch
                          no-footer
                          dataTable
                        "
                      >
                        <thead class="thead-dark">
                          <tr>
                            <th style="text-align: start">
                              Choose
                              <span>
                                <button
                                  style="margin-right: -31px"
                                  class="asc-desc-btn"
                                  @click="orderBy(1)"
                                >
                                  &uarr; &darr;
                                </button>
                              </span>
                            </th>
                            <th style="text-align: start">
                              Required
                              <span>
                                <button
                                  style="margin-right: -31px"
                                  class="asc-desc-btn"
                                  @click="orderBy(2)"
                                >
                                  &uarr; &darr;
                                </button>
                              </span>
                            </th>
                            <th style="text-align: start">
                              Serial
                            </th>
                            <th style="text-align: start">
                              Question
                              <span>
                                <button
                                  class="asc-desc-btn"
                                  @click="orderBy(3)"
                                >
                                  &uarr; &darr;
                                </button>
                              </span>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-if="tableLoaderQuest">
                            <td align="center" colspan="100">
                              <strong> processing</strong>
                            </td>
                          </tr>
                          <tr v-else v-for="(quest, ndx) in quests" :key="ndx">
                            <td style="padding-top: 3px; padding-bottom: 3px">
                              <!-- {{ quest.srNo }} -->
                              <!-- <div v-if="quest.isRequired == 'True'">
                                     <i class="fa fa-asterisk" aria-hidden="true"
                                     style="color: red;font-size: 10px;margin-top: -6px;
                                      position: absolute;"></i>
                                    <div class="col-lg-3 switchery-demo"
                                    >
                                    <label class="switch">
                                      <input :id="'questsCB' + quest.questId"  type="checkbox"  @change="quesPushInSelectedId(quest)"
                                      name="questsNameCB"/>
                                      <span class="slider round"></span>
                                    </label>
                                  </div>
                                   </div> -->
                              <div>
                                <div class="col-lg-3 switchery-demo">
                                  <label class="switch">
                                    <input
                                      :id="'questsCB' + quest.questId"
                                      type="checkbox"
                                      @change="quesPushInSelectedId(quest)"
                                      name="questsNameCB"
                                    />
                                    <span class="slider round"></span>
                                  </label>
                                </div>
                              </div>
                            </td>
                            <td style="padding-top: 3px; padding-bottom: 3px">
                              <div class="col-lg-3 switchery-demo">
                                <label class="switch text-center">
                                  <input
                                    class=""
                                    type="checkbox"
                                    v-model="quest.isRequired"
                                    @change="
                                      QuestionaireActiveChange(
                                        quest.questId,
                                        quest.isRequired,
                                        quest
                                      )
                                    "
                                    :disabled="updButton == 0"
                                  />
                                  <span class="slider round"></span>
                                </label>
                              </div>
                            </td>
                            <td>
                              <p>
                                <span class="hidden-xs-down row">
                                  <button
                                    v-if="
                                      QuestionDisableArrows(quest) === false
                                    "
                                    class="btn-floating btn-sm btn-success up question-arrow-button"
                                    :disabled="QuestionDisableArrows(quest)"
                                    style="border:none;background-color:#00CC99 "
                                    @click="QuestionUpArrow(quest, ndx)"
                                  >
                                    <i class="fas fa-arrow-up white-text"> </i>
                                  </button>
                                  <button
                                    v-else
                                    else
                                    class="btn-floating btn-sm btn-success up question-arrow-button"
                                    :disabled="QuestionDisableArrows(quest)"
                                    style="border:none;background-color:#808080 "
                                    @click="QuestionUpArrow(quest, ndx)"
                                  >
                                    <i class="fas fa-arrow-up white-text"> </i>
                                  </button>
                                  &nbsp;
                                  <button
                                    v-if="
                                      QuestionDisableArrows(quest) === false
                                    "
                                    class="btn-floating btn-sm btn-success up question-arrow-button"
                                    style="border:none;background-color:#00CC99"
                                    @click="QuestionDownArrow(quest, ndx)"
                                    :disabled="QuestionDisableArrows(quest)"
                                  >
                                    <i class="fas fa-arrow-down white-text"></i>
                                  </button>
                                  <button
                                    v-else
                                    class="btn-floating btn-sm btn-success up question-arrow-button"
                                    style="border:none;background-color:#808080 "
                                    @click="QuestionDownArrow(quest, ndx)"
                                    :disabled="QuestionDisableArrows(quest)"
                                  >
                                    <i class="fas fa-arrow-down white-text"></i>
                                  </button>

                                  <!-- <span id="reasonHandle"> {{ vtdt.vtd.reason }}</span></span> -->
                                </span>
                                <!-- <input type='number' v-model="quest.srNo"> -->
                              </p>
                            </td>
                            <td
                              style="
                                padding-top: 3px;
                                padding-bottom: 3px;
                                width: 100%;
                              "
                            >
                              <p>{{ quest.question }}</p>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <nav aria-label="Page navigation ">
                      <span style="padding-left: 40px" v-if="tableLoaderQuest">
                        Showing -- to -- of -- entires</span
                      >
                      <span
                        style="padding-left: 40px"
                        v-else-if="totalRows > pageSize * pageNumber"
                      >
                        Showing {{ totalRowsQcount * (pageNumber - 1) + 1 }} to
                        {{ totalRowsQcount * pageNumber }} of
                        {{ totalRows }} entires</span
                      >
                      <span style="padding-left: 40px" v-else
                        >Showing {{ totalRows - totalRowsQcount + 1 }} to
                        {{ totalRows }} of {{ totalRows }} entires</span
                      >
                      <ul class="pagination" style="float: right">
                        <li class="page-item colorActive">
                          <span v-if="pageNumber == 1">
                            <button
                              disabled
                              class="page-link disabledColor"
                              @click="pageChange('Previous')"
                            >
                              Previous
                            </button>
                          </span>
                          <span v-else>
                            <button
                              class="page-link"
                              @click="pageChange('Previous')"
                            >
                              Previous
                            </button>
                          </span>
                        </li>

                        <li
                          v-for="pageNum in totalPages"
                          :key="pageNum"
                          class="page-item colorActive"
                        >
                          <span v-if="pageNumber == pageNum"
                            ><button
                              class="page-link activeColor"
                              disabled
                              @click="pageChange(pageNum)"
                            >
                              {{ pageNum }}
                            </button>
                          </span>
                          <span v-else>
                            <button
                              class="page-link"
                              @click="pageChange(pageNum)"
                            >
                              {{ pageNum }}
                            </button></span
                          >
                        </li>

                        <li class="page-item colorActive">
                          <span v-if="pageNumber == totalPages">
                            <button
                              disabled
                              class="page-link disabledColor"
                              @click="pageChange('Next')"
                            >
                              Next
                            </button>
                          </span>
                          <span v-else>
                            <button
                              class="page-link"
                              @click="pageChange('Next')"
                            >
                              Next
                            </button>
                          </span>
                        </li>
                      </ul>
                    </nav>
                  </div>

                  <div class="row" id="" style="width: 100%; margin-left: 0px">
                    <h3 class="font-weight-bold h3Spacing m-t-10">Demo</h3>
                    <!-- <select
                          multiple="multiple"
                          id="questControl"
                          name="dummy009[]"
                        ></select> -->
                    <!-- this is List new section-->
                    <div id="" class="table-responsive">
                      <div
                        class="
                          dataTables_wrapper
                          container-fluid
                          dt-bootstrap4
                          no-footer
                        "
                      >
                        <div class="dataTables_length">
                          <span style="margin-right: 10px"
                            ><label for="">Show </label>
                          </span>
                          <select
                            v-model="pageSizeDemo"
                            class="form-control form-control-sm"
                            aria-label="Default select example"
                            @change="pageChange1(1)"
                          >
                            <option selected>50</option>
                            <option value="100">100</option>
                            <option value="500">500</option>
                            <option value="1000">1000</option>
                            <option value="2000">2000</option>
                          </select>

                          <span style="margin-left: 10px">
                            <label for=""> Entries </label></span
                          >
                        </div>
                        <div class="dataTables_filter">
                          <span class="float-right">
                            <span style="margin-right: 10px"
                              ><label for="Search">Search:</label></span
                            >
                            <input
                              type="text"
                              v-on:keydown="SearchDataTable1()"
                              v-model="filterDemo"
                              autocomplete="off"
                              name=""
                              id=""
                            />
                          </span>
                        </div>
                      </div>
                      <table
                        data-height="300"
                        class="
                          table
                          display
                          table-bordered table-striped
                          no-wrap
                          noSearch
                          no-footer
                          dataTable
                        "
                      >
                        <thead class="thead-dark">
                          <tr>
                            <th style="text-align: start">
                              Choose
                              <span>
                                <button
                                  style="margin-right: -31px"
                                  class="asc-desc-btn"
                                  @click="orderBy1(1)"
                                >
                                  &uarr; &darr;
                                </button>
                              </span>
                            </th>
                            <th style="text-align: start">
                              Required
                              <span>
                                <button
                                  style="margin-right: -31px"
                                  class="asc-desc-btn"
                                  @click="orderBy1(2)"
                                >
                                  &uarr; &darr;
                                </button>
                              </span>
                            </th>
                            <th style="text-align: start">
                              Serial
                            </th>
                            <th style="text-align: start">
                              Question
                              <span>
                                <button
                                  class="asc-desc-btn"
                                  @click="orderBy1(3)"
                                >
                                  &uarr; &darr;
                                </button>
                              </span>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-if="tableLoaderDemo">
                            <td align="center" colspan="100">
                              <strong> processing</strong>
                            </td>
                          </tr>
                          <tr v-else v-for="(demo, ndx) in demos" :key="ndx">
                            <!----  --->
                            <td style="padding-top: 3px; padding-bottom: 3px">
                              <!-- this is demotable demo table -->
                              <div>
                                <div
                                  v-if="getChanges(demo) == true"
                                  class="col-lg-3 switchery-demo"
                                >
                                  <label class="switch">
                                    <input
                                      type="checkbox"
                                      v-model="checked"
                                      :disabled="true"
                                    />
                                    <span class="slider round"></span>
                                  </label>
                                </div>
                                <div v-else class="col-lg-3 switchery-demo">
                                  <label class="switch">
                                    <input
                                      :id="'demosCB' + demo.demoId"
                                      v-model="demo.Checked"
                                      type="checkbox"
                                      @change="demosPushInSelectedId(demo)"
                                      name="demosNameCB"
                                    />
                                    <span class="slider round"></span>
                                  </label>
                                </div>
                              </div>
                            </td>
                            <td style="padding-top: 3px; padding-bottom: 3px">
                              <div class="col-lg-3 switchery-demo">
                                <label class="switch text-center">
                                  <input
                                    class=""
                                    type="checkbox"
                                    v-model="demo.isRequired"
                                    @change="
                                      DemoActiveChange(
                                        demo.demoId,
                                        demo.isRequired,
                                        demo
                                      )
                                    "
                                    :disabled="
                                      updButton == 0 || getChanges(demo)
                                    "
                                  />
                                  <span class="slider round"></span>
                                </label>
                              </div>
                            </td>
                            <td>
                              <p>
                                <span class="hidden-xs-down row">                                  
                                  <button
                                    v-if="
                                      DemoDisableArrows(demo, ndx) === false
                                    "
                                    class="btn-floating btn-sm btn-success up question-arrow-button"
                                    :disabled="DemoDisableArrows(demo)"
                                    style="border:none;background-color:#00CC99 "
                                    @click="demoUpArrow(demo, ndx)"
                                  >
                                    <i class="fas fa-arrow-up white-text"> </i>
                                  </button>
                                  <button
                                    v-else
                                    else
                                    class="btn-floating btn-sm btn-success up question-arrow-button"
                                    :disabled="DemoDisableArrows(demo, ndx)"
                                    style="border:none;background-color:#808080 "
                                    @click="demoUpArrow(demo, ndx)"
                                  >
                                    <i class="fas fa-arrow-up white-text"> </i>
                                  </button>
                                  &nbsp;
                                  <button
                                    v-if="
                                      DemoDisableArrows(demo, ndx) === false
                                    "
                                    class="btn-floating btn-sm btn-success up question-arrow-button"
                                    style="border:none;background-color:#00CC99"
                                    @click="demoDownArrow(demo, ndx)"
                                    :disabled="DemoDisableArrows(demo, ndx)"
                                  >
                                    <i class="fas fa-arrow-down white-text"></i>
                                  </button>
                                  <button
                                    v-else
                                    class="btn-floating btn-sm btn-success up question-arrow-button"
                                    style="border:none;background-color:#808080 "
                                    @click="demoDownArrow(demo, ndx)"
                                    :disabled="DemoDisableArrows(demo, ndx)"
                                  >
                                    <i class="fas fa-arrow-down white-text"></i>
                                  </button>
                                  <!-- {{demo.srNo}} --><!-- demo srno -->
                                  <!-- <span id="reasonHandle"> {{ vtdt.vtd.reason }} </span></span> -->
                                </span>
                                <!-- <input type='number' v-model="quest.srNo"> -->
                              </p>
                            </td>
                            <td
                              style="
                                padding-top: 3px;
                                padding-bottom: 3px;
                                width: 100%;
                              "
                            >
                              <p>{{ demo.demoName }}</p>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <nav aria-label="Page navigation ">
                      <span style="padding-left: 40px" v-if="tableLoaderDemo">
                        Showing -- to -- of -- entires</span
                      >
                      <span
                        style="padding-left: 40px"
                        v-else-if="
                          totalRowsDemo > pageSizeDemo * pageNumberDemo
                        "
                      >
                        Showing
                        {{ totalRowsDcount * (pageNumberDemo - 1) + 1 }} to
                        {{ totalRowsDcount * pageNumberDemo }} of
                        {{ totalRowsDemo }} entires</span
                      >
                      <span style="padding-left: 40px" v-else>
                        Showing {{ totalRowsDemo - totalRowsDcount + 1 }} to
                        {{ totalRowsDemo }} of {{ totalRowsDemo }} entires</span
                      >
                      <ul
                        class="pagination"
                        style="float: right; margin-left: 325px"
                      >
                        <li class="page-item colorActive">
                          <span v-if="pageNumberDemo == 1">
                            <button
                              disabled
                              class="page-link disabledColor"
                              @click="pageChange1('Previous')"
                            >
                              Previous
                            </button>
                          </span>
                          <span v-else>
                            <button
                              class="page-link"
                              @click="pageChange1('Previous')"
                            >
                              Previous
                            </button>
                          </span>
                        </li>

                        <li
                          v-for="pageNum in totalPagesDemo"
                          :key="pageNum"
                          class="page-item colorActive"
                        >
                          <span v-if="pageNumberDemo == pageNum"
                            ><button
                              class="page-link activeColor"
                              disabled
                              @click="pageChange1(pageNum)"
                            >
                              {{ pageNum }}
                            </button>
                          </span>
                          <span v-else>
                            <button
                              class="page-link"
                              @click="pageChange1(pageNum)"
                            >
                              {{ pageNum }}
                            </button></span
                          >
                        </li>

                        <li class="page-item colorActive">
                          <span v-if="pageNumberDemo == totalPagesDemo">
                            <button
                              disabled
                              class="page-link disabledColor"
                              @click="pageChange1('Next')"
                            >
                              Next
                            </button>
                          </span>
                          <span v-else>
                            <button
                              class="page-link"
                              @click="pageChange1('Next')"
                            >
                              Next
                            </button>
                          </span>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /.modal-content -->
    </Dialog>
    <!-- /.modal-dialog -->
    <!-- Stage Modal -->
  </div>
</template>

<script src='./VisitTypeJs.js'></script>

<style src="@vueform/multiselect/themes/default.css"></style>

<style>
@import "/node_modules/vue-select-sides/styles/themes/light.scss";

.swal2-container {
  z-index: 10000 !important;
}
.ms-container {
  background: transparent
    url("https://github.com/lou/multi-select/blob/master/img/switch.png?raw=true")
    no-repeat 50% 50%;
  /* background: transparent url('../img/switch.png') no-repeat 50% 50%; */
  width: 370px;
}

.ms-container:after {
  content: ".";
  display: block;
  height: 0;
  line-height: 0;
  font-size: 0;
  clear: both;
  min-height: 0;
  visibility: hidden;
}

.ms-container .ms-selectable,
.ms-container .ms-selection {
  background: #fff;
  color: #555555;
  float: left;
  width: 45%;
}

.ms-container .ms-selection {
  float: right;
}

.ms-container .ms-list {
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  -moz-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  -webkit-transition: border linear 0.2s, box-shadow linear 0.2s;
  -moz-transition: border linear 0.2s, box-shadow linear 0.2s;
  -ms-transition: border linear 0.2s, box-shadow linear 0.2s;
  -o-transition: border linear 0.2s, box-shadow linear 0.2s;
  transition: border linear 0.2s, box-shadow linear 0.2s;
  border: 1px solid #ccc;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
  position: relative;
  height: 200px;
  padding: 0;
  overflow-y: auto;
}

.ms-container .ms-list.ms-focus {
  border-color: rgba(82, 168, 236, 0.8);
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(82, 168, 236, 0.6);
  -moz-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(82, 168, 236, 0.6);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(82, 168, 236, 0.6);
  outline: 0;
  outline: thin dotted \9;
}

.ms-container ul {
  margin: 0;
  list-style-type: none;
  padding: 0;
}

.ms-container .ms-optgroup-container {
  width: 100%;
}

.ms-container .ms-optgroup-label {
  margin: 0;
  padding: 5px 0px 0px 5px;
  cursor: pointer;
  color: #999;
}

.ms-container .ms-selectable li.ms-elem-selectable,
.ms-container .ms-selection li.ms-elem-selection {
  border-bottom: 1px #eee solid;
  padding: 2px 10px;
  color: #555;
  font-size: 14px;
}

.ms-container .ms-selectable li.ms-hover,
.ms-container .ms-selection li.ms-hover {
  cursor: pointer;
  color: #fff;
  text-decoration: none;
  background-color: #08c;
}

.ms-container .ms-selectable li.disabled,
.ms-container .ms-selection li.disabled {
  background-color: #eee;
  color: #aaa;
  cursor: text;
}

#span_1 {
  font-weight: 400;
  color: white;
  border-radius: 5px;
  max-width: 66ch;
  background: #00c292;
  padding: 5px;
}

#span11 {
  background: #e46a76;
  color: white;
  font-weight: 400;
  border-radius: 5px;
  max-width: 66ch;
  padding: 5px;
}

.quests-demos {
  text-align: left;
}
</style>
<style lang="scss" scoped>
.p-multiselect {
  width: 15rem;
}

p {
  word-break: break-all;
  word-wrap: break-word;
  white-space: pre-wrap;
}

::v-deep(.multiselect-custom) {
  .p-multiselect-label:not(.p-placeholder) {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }

  .country-item-value {
    padding: 0.25rem 0.5rem;
    border-radius: 3px;
    display: inline-flex;
    margin-right: 0.5rem;
    background-color: var(--primary-color);
    color: var(--primary-color-text);

    img.flag {
      width: 17px;
    }
  }
}

@media screen and (max-width: 640px) {
  .p-multiselect {
    width: 70%;
  }
}

@media screen and (min-width: 1024px) {
  #reasonHandle {
    display: block !important;
  }
}

#step-tabs {
  display: block !important;
}

.p-button {
  margin: 0.3rem 0.5rem;
  min-width: 10rem;
}

p {
  margin: 0;
}

.confirmation-content {
  display: flex;
  align-items: center;
  justify-content: center;
}

.p-dialog .p-button {
  min-width: 6rem;
}

div.b {
  white-space: nowrap;
  width: 110px;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: -24px;
  margin-left: 62px;
}
div.main-name-short {
  white-space: nowrap;
  width: 165px;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-left: 37.8px;
}
.activeColor {
  background-color: #fb9678;
  color: white;
}
.colorActive {
  color: #f95c2e;
}
.disabledColor {
  color: gray;
  background: lightgrey;
}
.asc-desc-btn {
  background-color: transparent;
  background-repeat: no-repeat;
  border: none;
  cursor: pointer;
  overflow: hidden;
  outline: none;
  color: honeydew;
  float: right;
}
.question-arrow-button {
  display: block;
  background-color: gray;
  color: white;
  border: none;
  outline: none;
}
</style>
